
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("9ewR5"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("9ewR5", function(module, exports) {

let $6b8ee8390e493747$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6b8ee8390e493747$var$load("cRtGo"),
    $6b8ee8390e493747$var$load("3Zwna"),
    $6b8ee8390e493747$var$load("di1Y5"),
    $6b8ee8390e493747$var$load("aYECQ"),
    $6b8ee8390e493747$var$load("55OBD"),
    $6b8ee8390e493747$var$load("gfGrm"),
    $6b8ee8390e493747$var$load("24u6w"),
    $6b8ee8390e493747$var$load("27glK"),
    $6b8ee8390e493747$var$load("bvY53"),
    $6b8ee8390e493747$var$load("l8Ar8"),
    $6b8ee8390e493747$var$load("gFEtJ"),
    $6b8ee8390e493747$var$load("7jSfd"),
    $6b8ee8390e493747$var$load("4HZlX"),
    $6b8ee8390e493747$var$load("kDqHr"),
    $6b8ee8390e493747$var$load("gT8XU"),
    $6b8ee8390e493747$var$load("3GuOt"),
    $6b8ee8390e493747$var$load("3Mspc"),
    $6b8ee8390e493747$var$load("9aQIt"),
    $6b8ee8390e493747$var$load("XZauT"),
    $6b8ee8390e493747$var$load("4S1SF"),
    $6b8ee8390e493747$var$load("lm9Lt"),
    $6b8ee8390e493747$var$load("9wPDc"),
    $6b8ee8390e493747$var$load("1MWOL"),
    $6b8ee8390e493747$var$load("6fQco"),
    $6b8ee8390e493747$var$load("aOY32"),
    $6b8ee8390e493747$var$load("3MYQs"),
    $6b8ee8390e493747$var$load("6SWFK"),
    $6b8ee8390e493747$var$load("5zapo"),
    $6b8ee8390e493747$var$load("jiFtb"),
    $6b8ee8390e493747$var$load("9atVd"),
    $6b8ee8390e493747$var$load("iivLa"),
    $6b8ee8390e493747$var$load("6wr18"),
    $6b8ee8390e493747$var$load("dek7I"),
    $6b8ee8390e493747$var$load("6iz6l"),
    $6b8ee8390e493747$var$load("4SCW2"),
    $6b8ee8390e493747$var$load("fdKpi"),
    $6b8ee8390e493747$var$load("ffEVr"),
    $6b8ee8390e493747$var$load("hhss7"),
    $6b8ee8390e493747$var$load("l22f4"),
    $6b8ee8390e493747$var$load("eTYdV"),
    $6b8ee8390e493747$var$load("Wowvf"),
    $6b8ee8390e493747$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("2jLeQ"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("2jLeQ", function(module, exports) {

let $1b01fface3d898fa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b01fface3d898fa$var$load("cRtGo"),
    $1b01fface3d898fa$var$load("3Zwna"),
    $1b01fface3d898fa$var$load("6wr18"),
    $1b01fface3d898fa$var$load("3j4Bc"),
    $1b01fface3d898fa$var$load("27glK"),
    $1b01fface3d898fa$var$load("bvY53"),
    $1b01fface3d898fa$var$load("ffEVr"),
    $1b01fface3d898fa$var$load("fIjMV"),
    $1b01fface3d898fa$var$load("psI7s"),
    $1b01fface3d898fa$var$load("6bVVs"),
    $1b01fface3d898fa$var$load("7mo6o"),
    $1b01fface3d898fa$var$load("eTYdV"),
    $1b01fface3d898fa$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("lQzPE"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("lQzPE", function(module, exports) {

let $fe7a3fce2d1818e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fe7a3fce2d1818e7$var$load("l0guZ"),
    $fe7a3fce2d1818e7$var$load("c0JsV"),
    $fe7a3fce2d1818e7$var$load("h3ABO"),
    $fe7a3fce2d1818e7$var$load("2oPKP"),
    $fe7a3fce2d1818e7$var$load("gSg0R"),
    $fe7a3fce2d1818e7$var$load("dafa3"),
    $fe7a3fce2d1818e7$var$load("iEUHW"),
    $fe7a3fce2d1818e7$var$load("kbwlB"),
    $fe7a3fce2d1818e7$var$load("2YffH"),
    $fe7a3fce2d1818e7$var$load("9XOeB"),
    $fe7a3fce2d1818e7$var$load("xu7ej"),
    $fe7a3fce2d1818e7$var$load("iQ4FP"),
    $fe7a3fce2d1818e7$var$load("T6sdO"),
    $fe7a3fce2d1818e7$var$load("cCWjv"),
    $fe7a3fce2d1818e7$var$load("7202t"),
    $fe7a3fce2d1818e7$var$load("9anPW"),
    $fe7a3fce2d1818e7$var$load("7VVIa"),
    $fe7a3fce2d1818e7$var$load("6wmiZ"),
    $fe7a3fce2d1818e7$var$load("im1VN"),
    $fe7a3fce2d1818e7$var$load("eD3Si"),
    $fe7a3fce2d1818e7$var$load("7usgn"),
    $fe7a3fce2d1818e7$var$load("c7Big"),
    $fe7a3fce2d1818e7$var$load("2SaXB"),
    $fe7a3fce2d1818e7$var$load("gnDXu"),
    $fe7a3fce2d1818e7$var$load("5XC9j"),
    $fe7a3fce2d1818e7$var$load("di1Y5"),
    $fe7a3fce2d1818e7$var$load("aYECQ"),
    $fe7a3fce2d1818e7$var$load("gfGrm"),
    $fe7a3fce2d1818e7$var$load("24u6w"),
    $fe7a3fce2d1818e7$var$load("l8Ar8"),
    $fe7a3fce2d1818e7$var$load("lTK3c"),
    $fe7a3fce2d1818e7$var$load("1WXdc"),
    $fe7a3fce2d1818e7$var$load("b2FtX"),
    $fe7a3fce2d1818e7$var$load("2tuEe"),
    $fe7a3fce2d1818e7$var$load("9AMyR"),
    $fe7a3fce2d1818e7$var$load("eKJoG"),
    $fe7a3fce2d1818e7$var$load("6iz6l"),
    $fe7a3fce2d1818e7$var$load("4SCW2"),
    $fe7a3fce2d1818e7$var$load("g6ldM"),
    $fe7a3fce2d1818e7$var$load("gf3H1"),
    $fe7a3fce2d1818e7$var$load("breTf"),
    $fe7a3fce2d1818e7$var$load("ftrp4"),
    $fe7a3fce2d1818e7$var$load("AJVgg"),
    $fe7a3fce2d1818e7$var$load("bJaqQ"),
    $fe7a3fce2d1818e7$var$load("cRtGo"),
    $fe7a3fce2d1818e7$var$load("6wr18"),
    $fe7a3fce2d1818e7$var$load("jvHRs"),
    $fe7a3fce2d1818e7$var$load("27glK"),
    $fe7a3fce2d1818e7$var$load("bvY53"),
    $fe7a3fce2d1818e7$var$load("hhss7"),
    $fe7a3fce2d1818e7$var$load("Wowvf"),
    $fe7a3fce2d1818e7$var$load("ffEVr"),
    $fe7a3fce2d1818e7$var$load("fIjMV"),
    $fe7a3fce2d1818e7$var$load("psI7s"),
    $fe7a3fce2d1818e7$var$load("6bVVs"),
    $fe7a3fce2d1818e7$var$load("7mo6o"),
    $fe7a3fce2d1818e7$var$load("jnVKv"),
    $fe7a3fce2d1818e7$var$load("3Zwna"),
    $fe7a3fce2d1818e7$var$load("7EorR"),
    $fe7a3fce2d1818e7$var$load("bgHzk"),
    $fe7a3fce2d1818e7$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.6cfa2dd0.js.map
